import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=14f070ef&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=14f070ef&lang=scss&scoped=true&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f070ef",
  null
  
)

export default component.exports